<template lang="html">
  <div>
    <form>
      <v-container>
        <v-row>
          <v-col cols="12">
            <v-text-field
              v-model="username"
              v-validate="'required'"
              :error-messages="errors.collect('username')"
              data-vv-name="username"
              label="Username*"
              autocomplete="username"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="user_id"
              v-validate="'integer|moreThanZero'"
              :error-messages="errors.collect('user_id')"  
              data-vv-name="user_id"
              data-vv-as="user ID used for attendance"
              type="number"
              label="Attendance User ID"
              @keydown.native="['e', 'E', '+', '-', '.'].includes($event.key) && $event.preventDefault()"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              ref="password"
              v-model="password"
              v-validate="'required'"
              :error-messages="errors.collect('password')"
              data-vv-name="password"
              label="Password*"
              type="password"
              autocomplete="new-password"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="confirmPassword"
              v-validate="'required|confirmed:password'"
              :error-messages="errors.collect('confirmPassword')"
              data-vv-name="confirmPassword"
              data-vv-as="password"
              label="Confirm Password*"
              type="password"
              autocomplete="new-password"
            />
          </v-col>
        </v-row>
      </v-container>
    </form>
    
    <v-card-actions>
      <v-spacer />
      <v-btn 
        :disabled="progressing || draftProgressing"
        text
        @click="closeDialog"
      >
        Cancel
      </v-btn>
      <v-btn 
        :disabled="progressing || draftProgressing"
        text
        @click="goPrevious"
      >
        Go back
      </v-btn>
      <v-btn
        :disabled="(!username || !password || !confirmPassword) || progressing"
        :loading="draftProgressing"
        color="hrissecondary"
        class="white--text"
        @click="saveAsDraft"
      >
        Save
      </v-btn> 
      <v-btn
        :loading="progressing"
        :disabled="draftProgressing"
        color="hrissecondary"
        class="white--text"     
        @click="submitForm"
      >
        Submit
      </v-btn>
    </v-card-actions>
  </div>
</template>

<script>
  export default {
    $_veeValidate: {
      validator: 'new', 
    },
    data () {
      return {
        progressing: false,
        password: null,
        confirmPassword: null,
        username: null,
        user_id: null,
        draftProgressing: false,
      }
    },
    mounted () {
      this.$validator.extend('moreThanZero', {
        getMessage (field, args) {
          return 'Invalid ID, user ID must be greater than 0'
        },
        validate (value, args) {
          return value > 0
        },
      })
    },
    methods: {
      goPrevious () {
        this.$emit('previous-step')
      },
      loadingTrue () {
        this.progressing = true
      },
      loadingFalse () {
        this.progressing = false
      },
      submitForm () {
        this.$validator.validateAll().then((result) => {
          if (!result) return
          this.$emit('submit-form')
        })
      },
      getFormData () {
        return {
          username: this.username,
          password: this.password,
          user_id: this.user_id,
        }
      },
      resetData () {
        this.username = null
        this.password = null
        this.confirmPassword = null
        this.user_id = null
        
        this.$validator.reset()
      },
      saveAsDraft () {
        this.draftProgressing = true
        this.$validator.validateAll().then((result) => {
          if (!result) return

          this.$emit('save-as-draft')
        })
      },
      closeDialog () {
        this.$emit('close-dialog')
      },
    },
  }
</script>
